// extracted by mini-css-extract-plugin
module.exports = {"badge":"personal-plan-badge_badge__KCztZ"};